import React from "react"
import "./ToggleSwitch.scss"

export default function ToggleSwitch({ checked, onChange, ...props }: any) {
  return (
    <label className="toggle-switch-wrapper">
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e)}
        {...props}
      />
      <span className="slider"></span>
    </label>
  )
}
